"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

var hex_1 = require("./hex");

function toBuffer(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Buffer.alloc(0);
  var result = null;

  if (value) {
    switch (typeof value) {
      case 'string':
        value = value;
        result = hex_1.isHex(value, 'data') ? Buffer.from(value.slice(2), 'hex') : Buffer.from(value, constants_1.BUFFER_TEXT_ENCODING);
        break;

      case 'object':
        if (Buffer.isBuffer(value)) {
          result = value;
        }

        break;
    }
  }

  return result || defaultValue;
}

exports.toBuffer = toBuffer;